import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'animate.css'
import '@/assets/font/font.css'
import 'element-ui/lib/theme-chalk/index.css'
import '/node_modules/flag-icons/css/flag-icons.min.css'
import { extractCriticalCSS } from '@/utils/criticalCSS'
import { loadFonts, preloadFonts } from '@/utils/fontLoader'
import vueLazyload from 'vue-lazyload'
import i18n from '@/lang/index'
import plugins from '@/plugins'
import { initializeLanguageManager } from '@/utils/languageManager'
import { initRouterHelper } from '@/utils/routerHelper'
import { getUserIp } from '@/api/ip'

// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
// 收藏组件
import FavStar from "@/components/FavStar"
// 全局事件总线
import EventBus from '@/utils/eventBus'

// Vue配置
Vue.use(ElementUI)
Vue.use(vueLazyload, {
  // 生产环境下使用更加严格的图片加载策略
  preLoad: 1.3,
  error: require('@/assets/image/none/loading-fail.jpg'), // 错误时显示的图片
  loading: require('@/assets/image/loading.gif'), // 加载中显示的图片
  attempt: 3, // 尝试加载的次数
  // 自定义图片加载处理
  filter: {
    progressive (listener, options) {
      // 为不同环境下的图片路径提供适当的处理
      if (process.env.NODE_ENV === 'production') {
        // 生产环境下的特殊处理
        if (listener.src && !listener.src.startsWith('http') && !listener.src.startsWith('/')) {
          // 确保相对路径的图片也能正确加载
          listener.src = listener.src
        }
      }
    }
  }
})

// 异步获取用户IP并初始化插件
let initialIP = null
async function initializePlugins() {
  try {
    // 尝试获取用户IP
    const ipResponse = await getUserIp()
    if (ipResponse && ipResponse.data && ipResponse.data.ip) {
      initialIP = ipResponse.data.ip
      // 设置到window对象，以便gtagHelper可以访问
      window.userIP = initialIP
      console.log('User IP retrieved:', initialIP)
    }
  } catch (error) {
    console.warn('Failed to retrieve user IP:', error)
  }
  
  // 使用初始IP注册插件
  Vue.use(plugins, {
    initialIP: initialIP
  })
  
  Vue.use(EventBus)
  Vue.config.productionTip = false
}

// 立即执行插件初始化
initializePlugins();

// 注册全局组件
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)
Vue.component('FavStar', FavStar)

// 性能优化：内联关键CSS
const style = document.createElement('style')
style.textContent = extractCriticalCSS()
document.head.appendChild(style)

// 预加载关键资源
preloadFonts()

// 异步加载非关键CSS
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(() => {
    import('@/utils/criticalCSS').then(({ loadNonCriticalCSS }) => {
      loadNonCriticalCSS()
    })
  })
} else {
  setTimeout(() => {
    import('@/utils/criticalCSS').then(({ loadNonCriticalCSS }) => {
      loadNonCriticalCSS()
    })
  }, 2000)
}

// 加载字体
loadFonts()

// 应用初始化函数
async function initializeApp() {
  try {
    // 初始化路由助手
    initRouterHelper(router)
    
    // 初始化语言管理器
    await initializeLanguageManager()
  } catch (error) {
    console.error('App initialization failed:', error)
  }
  
  // 创建Vue实例
  new Vue({
    router,
    i18n,
    store,
    render: h => h(App),
  }).$mount('#app')
}

// 百度统计路由追踪
router.beforeEach((to, from, next) => {
  if (to.path && window._hmt) {
    window._hmt.push(['_trackPageview', '/#' + to.fullPath])
  }
  next()
})

// 屏蔽所有console输出
// 保存原始console方法（可选，如需调试可取消注释）
// const originalConsole = {
//   log: console.log,
//   warn: console.warn,
//   error: console.error
// }

// 重写console方法为空函数
console.log = function() {}
console.warn = function() {}
console.error = function() {}
console.info = function() {}
console.debug = function() {}
console.table = function() {}
console.group = function() {}
console.groupEnd = function() {}

// 启动应用
initializeApp()
